import { normalizeVatNumber } from "../../../../utils/vatNumberUtils";
import { stripStreetPrefix } from "../components/sede/SedeAziendale";

const STRING_PATCH_FIELDS = [
  ["nomeCommerciale", "businessName"],
  ["ragioneSociale", "tradeName"],
  ["indirizzoEmail", "email"],
  ["sitowebAziendale", "websiteUrl"],
  ["numeroTelefono", "phoneNumber"],
  ["nomeReferente", "referringName"],
  ["cognomeReferente", "referringSurname"],
];

function assignTrimmed(patch, apiKey, value) {
  patch[apiKey] = (value ?? "").trim();
}

export function buildProfilePatch({ vendorForm, baseData, base64 }) {
  const patchData = { role: "vendor" };
  const origLogo = baseData.logo ?? "";

  for (const [formKey, apiKey] of STRING_PATCH_FIELDS) {
    if (vendorForm[formKey] !== baseData[formKey]) {
      patchData[apiKey] = vendorForm[formKey];
    }
  }

  if (vendorForm.partitaIVA !== baseData.partitaIVA) {
    patchData.vatNumber = normalizeVatNumber(vendorForm.partitaIVA);
  }
  if (vendorForm.codiceFiscale !== baseData.codiceFiscale) {
    patchData.taxCode = (vendorForm.codiceFiscale ?? "").trim();
  }
  if (vendorForm.indirizzoPec !== baseData.indirizzoPec) {
    const t = (vendorForm.indirizzoPec ?? "").trim();
    patchData.pec = t === "" ? "" : t;
  }
  if (vendorForm.codiceSDI !== baseData.codiceSDI) {
    const t = (vendorForm.codiceSDI ?? "").trim().toUpperCase();
    patchData.sdiCode = t === "" ? "" : t;
  }
  if (vendorForm.emailReferente !== baseData.emailReferente) {
    assignTrimmed(patchData, "refEmail", vendorForm.emailReferente);
  }
  if (vendorForm.telefonoReferente !== baseData.telefonoReferente) {
    assignTrimmed(patchData, "refPhoneNumber", vendorForm.telefonoReferente);
  }
  if (vendorForm.emailPubblica !== baseData.emailPubblica) {
    assignTrimmed(patchData, "pubEmail", vendorForm.emailPubblica);
  }
  if (vendorForm.urlSftp !== baseData.urlSftp) {
    assignTrimmed(patchData, "sftpServerUrl", vendorForm.urlSftp);
  }
  if (vendorForm.utenteSftp !== baseData.utenteSftp) {
    assignTrimmed(patchData, "catalogUsername", vendorForm.utenteSftp);
  }
  if (vendorForm.passwordSftp !== baseData.passwordSftp) {
    assignTrimmed(patchData, "catalogPassword", vendorForm.passwordSftp);
  }

  const viaStripped = stripStreetPrefix(vendorForm.indirizzoVia ?? "");
  const baseViaStripped = stripStreetPrefix(baseData.indirizzoVia ?? "");
  if (viaStripped !== baseViaStripped) {
    patchData.addressVia = viaStripped;
  }
  if (vendorForm.indirizzoCivico !== baseData.indirizzoCivico) {
    patchData.addressCivico = vendorForm.indirizzoCivico ?? "";
  }
  if (vendorForm.indirizzoCap !== baseData.indirizzoCap) {
    patchData.addressCap = vendorForm.indirizzoCap ?? "";
  }
  if (vendorForm.indirizzoCitta !== baseData.indirizzoCitta) {
    patchData.addressComune = vendorForm.indirizzoCitta ?? "";
  }
  if (vendorForm.indirizzoProvincia !== baseData.indirizzoProvincia) {
    patchData.addressProvincia = vendorForm.indirizzoProvincia ?? "";
  }
  if (vendorForm.indirizzoRegione !== baseData.indirizzoRegione) {
    patchData.addressRegione = vendorForm.indirizzoRegione ?? "";
  }
  if (vendorForm.indirizzoStato !== baseData.indirizzoStato) {
    patchData.addressStato = vendorForm.indirizzoStato ?? "";
  }

  const curLogo = base64 ?? "";
  if (origLogo && !curLogo) {
    patchData.clearLogo = true;
  } else if (curLogo && curLogo !== origLogo) {
    patchData.logo = curLogo;
  }

  const hasPatch =
    Object.keys(patchData).length > 1 ||
    patchData.clearLogo === true ||
    patchData.logo !== undefined ||
    patchData.addressVia !== undefined ||
    patchData.addressCivico !== undefined ||
    patchData.addressCap !== undefined ||
    patchData.addressComune !== undefined ||
    patchData.addressProvincia !== undefined ||
    patchData.addressRegione !== undefined ||
    patchData.addressStato !== undefined;

  return { patchData, hasPatch };
}
